import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const LoginAsStudent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const access = params.get("access");
    const refresh = params.get("refresh");

    // برای دیباگ - ببینیم چی میرسه
    console.log("Access Token:", access);
    console.log("Refresh Token:", refresh);

    if (access && refresh) {
      try {
        // توکن‌ها رو مستقیم ذخیره کن (نیاز به decode نیست چون خودشون String هستن)
        localStorage.setItem("accessToken", access);
        localStorage.setItem("refreshToken", refresh);

        // بررسی کن که ذخیره شده
        const savedAccess = localStorage.getItem("accessToken");
        const savedRefresh = localStorage.getItem("refreshToken");
        console.log("Saved Access:", savedAccess);
        console.log("Saved Refresh:", savedRefresh);

        if (savedAccess && savedRefresh) {
          // با رفرش کامل صفحه به داشبورد برو
          window.location.href = "/dashboard";
        } else {
          setError("خطا در ذخیره توکن‌ها");
        }
      } catch (err) {
        console.error("خطا:", err);
        setError("خطا در پردازش توکن‌ها");
      }
    } else {
      // اگر توکنی نبود، به لاگین برگرد
      setError("توکن‌های ورود یافت نشد");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    }
  }, [location, navigate]);

  // نمایش خطا
  if (error) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        height: "100vh",
        flexDirection: "column",
        gap: "10px"
      }}>
        <div style={{ color: "red", fontSize: "18px" }}>❌ {error}</div>
        <div>در حال انتقال به صفحه ورود...</div>
      </div>
    );
  }

  return (
    <div style={{ 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      height: "100vh",
      flexDirection: "column",
      gap: "15px"
    }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <h5>در حال ورود به حساب دانش‌آموز...</h5>
      <p style={{ fontSize: "14px", color: "#666" }}>
        لطفاً چند لحظه صبر کنید
      </p>
    </div>
  );
};

export default LoginAsStudent;